import {
  REQUEST_SOURCE_SETTING_INTEGRATIONS,
  REQUEST_SOURCE_SETTING_INTEGRATIONS_ERROR,
  RECEIVE_SOURCE_SETTING_INTEGRATIONS
} from 'actions'
import createApiMiddlewareReducer from './utils/create-api-middleware-reducer'

export default function (state = {}, { type, payload, error }) {
  switch (type) {
    case RECEIVE_SOURCE_SETTING_INTEGRATIONS:
    case REQUEST_SOURCE_SETTING_INTEGRATIONS_ERROR:
    case REQUEST_SOURCE_SETTING_INTEGRATIONS:
      return reduce(state, { type, payload, error })
    default:
      return state
  }
}

const reducer = createApiMiddlewareReducer({
  receive: RECEIVE_SOURCE_SETTING_INTEGRATIONS,
  failure: REQUEST_SOURCE_SETTING_INTEGRATIONS_ERROR,
  request: REQUEST_SOURCE_SETTING_INTEGRATIONS
})

function reduce (state, { type, payload, error }) {
  const { workspaceSlug, sourceSettingSlug } = payload
  const key = `${workspaceSlug}-${sourceSettingSlug}`
  return {
    ...state,
    [key]: reducer(state[key], {
      type,
      payload,
      error
    })
  }
}



// WEBPACK FOOTER //
// ./reducers/source-setting-integrations.js